"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierMinimumPrice = void 0;
const typeorm_1 = require("typeorm");
const JournaledEntity_1 = require("../../JournaledEntity");
// eslint-disable-next-line import/no-cycle
const Supplier_1 = require("./Supplier");
const Price_1 = require("../../prices/entity/Price");
const CircularReference_1 = require("../../serialization/CircularReference");
let SupplierMinimumPrice = class SupplierMinimumPrice extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.SupplierMinimumPrice = SupplierMinimumPrice;
__decorate([
    (0, typeorm_1.OneToOne)(() => Supplier_1.Supplier, (s) => s.minimumPrice),
    (0, typeorm_1.JoinColumn)(),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Supplier_1.Supplier)
], SupplierMinimumPrice.prototype, "supplier", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sp) => sp.supplier),
    __metadata("design:type", String)
], SupplierMinimumPrice.prototype, "supplierId", void 0);
__decorate([
    (0, typeorm_1.Column)(() => Price_1.Price),
    __metadata("design:type", Price_1.Price)
], SupplierMinimumPrice.prototype, "price", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], SupplierMinimumPrice.prototype, "description", void 0);
exports.SupplierMinimumPrice = SupplierMinimumPrice = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], SupplierMinimumPrice);
